import {systemTraineeControllerImportTrainees} from "../../api/generated";

// Trainee operations a SYSTEM_ADMIN performs ON a chosen company — today just the bulk import behind
// the import-users page. Backed by the server's SystemTraineeController (/system/trainee/import).
//
// The /admin twin (../TraineeService.importTrainees) is ADMIN-only and is what a company admin uses;
// a company-less super-admin is refused there, so the super-admin path goes through /system with the
// target companyId in the request body.

// request: {companyId, trainerId, password, trainees: [{name, email, phone, ...}]}
// Resolves to {data: ImportTraineesResponse} — {totalProcessed, totalCreated, totalUpdated,
// totalSkipped, errors[]}.
export async function importTrainees(request) {
  const {data, error} = await systemTraineeControllerImportTrainees({body: request});
  if (error) throw error;
  return {data};
}
